
import PinyinMatch from 'pinyin-match';
import { valueEquals } from 'element-ui/lib/utils/util';
import { objDeepCopy } from '@/utils';

export default {
  name: 'WkUser', // 新建 user
  components: {},
  props: {
    radio: Boolean,
    headerShow: {
      type: Boolean,
      default: true
    },
    // isHide 可不显示 但数据源里包含
    options: Array,
    value: Array,
    // 取值字段
    props: {
      type: Object,
      default: function _default() {
        return {
          value: 'id',
          label: 'realname'
        };
      }
    },
    max: Number,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dataValue: [],
      searchInput: '',
      checkAll: false,
      isIndeterminate: false
    };
  },

  computed: {
    showOptions: function showOptions() {
      var _this = this;

      return this.options.filter(function (item) {
        return PinyinMatch.match(item[_this.props.label], _this.searchInput);
      });
    }
  },
  watch: {
    value: function value() {
      if (this.options && !this.radio) {
        var optionsLength = this.options.filter(function (item) {
          return !item.isHide;
        }).length;
        if (this.value.length == optionsLength && (this.value.length > 0 || optionsLength > 0)) {
          this.checkAll = true;
        } else {
          this.checkAll = false;
        }

        this.isIndeterminate = !!(!this.checkAll && this.value.length);
      }

      if (!valueEquals(this.value, this.dataValue)) {
        this.dataValue = objDeepCopy(this.value);
      }
    }
  },
  created: function created() {
    this.dataValue = objDeepCopy(this.value || []);
  },

  methods: {

    /**
     * 勾选
     */
    checkboxChange: function checkboxChange(val) {
      if (this.radio) {
        this.$emit('input', val.length ? [val[val.length - 1]] : []);

        // 单选直接关闭窗口
        this.$emit('close');
      } else {
        this.$emit('input', val);
      }
      this.$emit('change', val);
    },


    /**
     * 全部勾选
     */
    handleCheckAllChange: function handleCheckAllChange(val) {
      var _this2 = this;

      if (val) {
        var ids = [];
        this.options.forEach(function (item) {
          if (!item.isHide) {
            ids.push(item[_this2.props.value]);
          }
        });
        this.$emit('input', ids);
        this.$emit('change', val);
      } else {
        this.$emit('input', []);
        this.$emit('change', []);
      }
    },


    /**
     * 清空全部
     */
    clearAll: function clearAll() {
      this.$emit('input', []);
    }
  }
};